import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IButton } from '@kinet-open-network/client/shared/ui';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export interface IFieldButton
  extends IButton<(model: any, field: FormlyFieldConfig) => void> {
  tooltip?: string;
}

export interface ButtonWrapperProps extends FormlyFieldProps {
  button?: IFieldButton;
  buttons?: IFieldButton[];
}

@Component({
  selector: 'kon-filed-button-wrapper',
  imports: [ButtonModule, RouterModule, TooltipModule],
  template: ` @let buttons =
      props.buttons || (props.button ? [props.button] : []);

    @if (buttons.length) {
      <div class="flex flex-row items-stretch button-wrapper">
        <ng-container #fieldComponent></ng-container>

        @for (button of buttons; track $index) {
          <button
            pButton
            type="button"
            [label]="button.label ?? ''"
            [routerLink]="button.routerLink"
            [queryParams]="button.queryParams"
            (click)="button.command?.(this.model, this.field)"
            [icon]="button.icon ?? ''"
            [text]="button.text"
            [outlined]="button.outlined"
            [rounded]="button.rounded"
            [severity]="button.severity"
            [disabled]="isDisabled(button)"
            [size]="button.size"
            [loading]="button.loading ?? false"
            [pTooltip]="button.tooltip"
          ></button>
        }
      </div>
    } @else {
      <ng-container #fieldComponent></ng-container>
    }`,
  styleUrls: ['./field-button-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButtonWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<ButtonWrapperProps>
> {
  isDisabled(button?: IFieldButton) {
    if (button?.disabled !== undefined) {
      return button?.disabled === true;
    }

    return this.formControl.disabled;
  }
}
